<template>
  <div id="wrapper-app">
    <router-view />

    <b-alert
      :show="error.dismissCountDown"
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000"
      variant="danger"
      dismissible
      fade
      @dismissed="error.dismissCountDown = 0"
      @dismiss-count-down="error.dismissCountDown = $event"
    >
      {{ error.message }}
    </b-alert>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'
import { mapActions } from 'vuex'
import { BroadcastChannel } from 'broadcast-channel'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  name: 'app',
  mixins: [lmToasts],
  provide: {
    lumbredocs_v3: process?.env?.VUE_APP_LUMBREDOCS_V3 === 'yes'
  },
  data () {
    return {
      error: {
        dismissSecs: 5,
        dismissCountDown: 0,
        message: 'Ocurrio un error'
      }
    }
  },
  methods: {
    ...mapActions('settings', ['getCoreSettings', 'getHomeSettings']),

    defineBroadcastChannels () {
      const channel = new BroadcastChannel('logout')

      channel.onmessage = async event => {
        if (event && location.pathname !== '/login') {
          await channel.close()
          location.href = '/login'
        }
      }
    }
  },
  created () {
    this.getCoreSettings()
    this.getHomeSettings()
    this.defineBroadcastChannels()

    // TODO. este listener podria deprecarse y usar las toasts del mixin
    // En proceso de deprecarlo se eliminio de todas las vistas, solo quedo en
    // RemitosNewOrEdit.vue
    EventBus.$on('lmShowGlobalToast', (args = {}) => {
      const {
        toastMessage,
        toastAttributes
      } = args
      this.$bvToast.toast(toastMessage, toastAttributes)
    })

    EventBus.$on('onError', error => {
      if (!error.quotaError) {
        this.lmModalDangerMessage({
          btnText: this.$t('try_again'),
          resultSubtitle: this.$t('talk_to_admin'),
          message: error.message
        })
      } else {
        this.lmModalInformationMessage({
          message: error.quotaMessage,
          resultSubtitle: error.message,
          buttons: [
            {
              btnText: this.$t('close'),
              btnType: 'danger'
            },
            {
              btnText: this.$t('view_more'),
              btnCallback: async () => {
                this.$router.push('/ajustes?tab=1')
              }
            }
          ]
        })
      }
    })
  }
}
</script>

<style lang="sass">
  @import "@/sass/_lumbre.sass"
</style>
